import Model from 'flarum/common/Model';
export default class Round extends Model {
  name = Model.attribute('name');
  starts_at = Model.attribute('starts_at');
  ends_at = Model.attribute('ends_at');
  include_starting_pack = Model.attribute('include_starting_pack');
  myRanking = Model.hasOne('myRanking');
  apiEndpoint() {
    return '/catchthefish-rounds' + (this.exists ? '/' + this.data.id : '');
  }
}
flarum.reg.add('clarkwinkelmann-catch-the-fish', 'common/models/Round', Round);